import Button from 'shared/components/buttons/Button';
import ButtonGroup from 'shared/components/buttons/ButtonGroup';

Button.Group = ButtonGroup;

export {
  Button
};
